import React from 'react';
import { Link } from 'react-router-dom';

const Links = ({ to, title }) => {
  return (
    <Link
      to={to}
      target=""
      name="News Details"
      aria-label="Go to news details"
      rel="noopener noreferrer"
      className="url-link"
    >
      <img alt="attachment" src="/images/chatbot/attachment.png" />
      <h1 className="url-header">
        {title}
      </h1>

    </Link>
  );
};

export default Links;
